<template>
  <div>
    <b-modal v-model="confirmRemoveModal"
      title="Remover Arquivo"
      class="modal-primary"
      @ok="removeFile">

      Deseja remover o arquivo do item de Jurisprudencia? Ao confirmar essa ação o item não poderá ser recuperado.
      <br>
      Caso deseje substituir o arquivo recomendamos que inative esse item e crie um novo.
    </b-modal>

    <b-card title="Jurisprudencia" header-tag="header" footer-tag="footer">
      <div slot="header" class="row mb-0 align-items-right">
        <div class="col-12 text-right ">
          <div class="switch-container">
            <span class="switch-label mr-1">
              Status
            </span>

            <toggle-button class="mb-0"
              v-model="form.status"
              :width="70"
              :height="25"
              :labels="{checked: 'Ativo', unchecked: 'Inativo'}"/>
          </div>
        </div>
      </div>

      <div class="row">
        <b-form-group class="col-12 col-sm-6"
          label="* Nome"
          label-for="name">

          <b-form-input id="name"
            v-model="form.name"
            placeholder="Nome"
            required
            :class="{
              'is-invalid': submitted && form.errors.has('name'),
              'is-valid': submitted && !form.errors.has('name')
            }">
          </b-form-input>
        </b-form-group>

        <b-form-group class="col-12 col-md-6"
          label="Categoria"
          label-for="category_id">

          <multiselect v-model="selectedCategory"
            @select="updateForm('category_id', arguments[0])"
            placeholder="Selecione a categoria"
            :allowEmpty="true"
            :options="categories"
            label="name"
            :showLabels="false"
            track-by="id"
            :class="{
              'is-invalid': submitted && form.errors.has('category_id'),
              'is-valid': submitted && !form.errors.has('category_id')
            }" />
        </b-form-group>

        <b-form-group class="col-12"
          label="Fonte"
          label-for="source">

          <b-form-input id="source"
            v-model="form.source"
            placeholder="Fonte"
            :class="{
              'is-invalid': submitted && form.errors.has('source'),
              'is-valid': submitted && !form.errors.has('source')
            }">
          </b-form-input>
        </b-form-group>

        <b-form-group class="col-12"
          label="Anexo"
          label-for="file">

          <single-file-input id="file"
            @success="handleUploadFile"
            @remove-file="handleRemoveFile"
            :value="fileInstance"
            :url="uploadUrl">
          </single-file-input>
        </b-form-group>
      </div>

      <slot name="footer"></slot>
    </b-card>
  </div>
</template>

<script>
import { get, set, isEmpty } from 'lodash'
import { resolveHTTP } from '@/services/api'

export default {
  props: {
    form: {
      type: [Object],
      required: true
    },
    submitted: {
      type: Boolean,
      default: false
    },
    instance: {
      type: Object,
      default () {
        return {
          file: {}
        }
      }
    },
    http: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      confirmRemoveModal: false,
      locks: {
        categories: true
      },
      file: {},

      selectedCategory: null,
      categories: [],

      empty: {
        _attach_files: [],
        name: '',
        source: '',
        category_id: '',
        file: null,
        status: true
      }
    }
  },

  watch: {
    '$props': {
      handler: function (newProps) {
        if (!get(newProps, 'form.category_id', false)) {
          this.selectedCategory = null
        }

        if (isEmpty(!get(newProps, 'form._attach_files', false))) {
          this.clearFileInput()
        }
      },
      deep: true
    }
  },

  computed: {
    ready () {
      return !(this.locks.categories)
    },

    uploadUrl () {
      return this.http.routes.uploadFile(this.instance.id)
    },

    fileInstance () {
      let file = {}

      if (!isEmpty(this.file)) {
        file = this.file
      }

      if (!isEmpty(this.instance.file)) {
        file = this.instance.file
      }

      // if (!isEmpty(this._links)) {
      //   file['_links'] = this._links
      // }

      if (!isEmpty(this.instance._links)) {
        file['_links'] = this.instance._links
      }

      return file
    }
  },

  methods: {
    updateForm (path, value) {
      set(this.form, path, value ? value.id : null)
    },

    handleUploadFile (file, response, progress) {
      if (this.form._attach_files === undefined) {
        this.form._attach_files = this.form.initial._attach_files || []
      }
      this.form._attach_files.push(response)
      // 2. Let's set the media on the source for the upload field
      this.file = response
    },

    handleRemoveFile (file) {
      if (this.instance.id) {
        this.confirmRemoveModal = true
        return null
      }
      // If there is not a instance we can simply remove the file from the input,
      // and we will let the server to handle with garbage files
      this.clearFileInput()
    },

    removeFile () {
      const self = this
      self.confirmRemoveModal = false
      this.$Progress.start()
      self.http.destroyFile(self.instance.id, self.fileInstance.id)
        .then((res) => {
          self.clearFileInput()
          self.$toasted.success('Arquivo removido com sucesso')
          self.$emit('refresh')
        })
    },

    clearFileInput () {
      this.form._attach_files = []
      this.file = {}
    }
  },

  created () {
    const self = this

    resolveHTTP('/bl/jurisprudence-categories').index({ params: { _onepage: true } })
      .then(function (res) {
        self.categories = res.data.collection
        self.locks.categories = false

        self.selectedCategory = self.form.category_id
          ? self.categories.find((o) => o.id === self.form.category_id)
          : null
      })

    if (self.instance.id) {
      self.form.withData(self.instance).setInitialValues(self.instance)

      self.form.category_id = self.instance.category_id || null
    } else {
      self.form.withData(self.empty).setInitialValues(self.empty)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/Bl/JurisprudenceFile.vue